import { required } from '@vuelidate/validators'

export const ScopeValidation = {
    scope: { required },
    description: { required },
}
